/**
 * @desc 锁定顺延
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/wms/changeOrder/lock`, {
      method: "POST",

      ...options,
    }),
  );
}
